import React from "react";
import { useLocation } from "react-router-dom";
import Router from "./routes";
import { keycloak, isKeycloakEnabled } from "./keycloak";
import { SpinnerWrapper } from "@components/Common/SpinnerWrapper";
export default function App(): any {
    const location = useLocation();
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const uidUserEntity = localStorage.getItem("Uid_Entitie_User");
    const [isLoading, setIsLoading] = React.useState(
        !(location.pathname === "/login" || location.pathname === "/")
    );
    const fetchListUidEntityBeta = async () => {
        try {
            const url = `${
                process.env.REACT_APP_UUID_BETA
            }?cacheBuster=${Date.now()}`;
            const response = await fetch(`${url}`);
            if (!response.ok) {
                throw new Error(
                    `Erreur lors du chargement des données: ${response.status} ${response.statusText}`
                );
            }
            const data = await response.json();

            return data;
        } catch (error) {
            // eslint-disable-next-line
            console.error(
                "Erreur lors du chargement de listUidEntity :",
                error
            );
            return [];
        }
    };

    const AuthenticatedApp: React.FC = () => {
        const { useKeycloak } = require("@react-keycloak/web");
        const { keycloak, initialized } = useKeycloak();

        if (!initialized || !keycloak.authenticated) {
            return <SpinnerWrapper />;
        }

        return <Router />;
    };

    React.useEffect(() => {
        if (
            uidUserEntity &&
            process.env.REACT_APP_BETA !== process.env.REACT_APP_PROD
        ) {
            fetchListUidEntityBeta().then((UidEntityBeta) => {
                const isUserBeta = UidEntityBeta.some(
                    (item: any) => item.uuidEntity === uidUserEntity
                );

                const redirectTo = isUserBeta
                    ? process.env.REACT_APP_BETA
                    : process.env.REACT_APP_PROD;

                if (redirectTo && redirectTo !== baseUrl) {
                    localStorage.clear();
                    const newUrl = `${redirectTo}`;
                    try {
                        window.location.replace(newUrl);
                    } catch (error) {
                        // eslint-disable-next-line
                        console.error("Erreur lors de la redirection :", error);
                    }
                }
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [uidUserEntity]);
    if (isLoading) return null;

    if (isKeycloakEnabled && keycloak) {
        return <AuthenticatedApp />;
    }
    return <Router />;
}
